import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Box, Button, Divider, FormHelperText, TextField, Link } from '@mui/material';
import useAuth from '../../../hooks/useAuth';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { Link as RouterLink } from 'react-router-dom';

const LoginJWT = (props) => {
  const isMountedRef = useIsMountedRef();
  const { login, openForgot } = useAuth();

  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
        submit: null
      }}
      validationSchema={Yup
        .object()
        .shape({
          email: Yup
            .string()
            .email('Must be a valid email')
            .max(255)
            .required('Email is required'),
          password: Yup
            .string()
            // .matches("^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{18,}$")
            .required('Password is required')
        })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          var data = await login(values.email, values.password);
          console.log("LOGIN RES:", data)
          if (data !== undefined && data.success && isMountedRef.current) {
            setStatus({ success: true });
            setSubmitting(false);
          } else {
            setStatus({ success: false });
            setErrors({ submit: data.message });
            setSubmitting(false);
          }

        } catch (err) {
          console.log("inCATCH", err);
          console.error(err);
          if (isMountedRef.current) {
            setStatus({ success: false });
            setErrors({ submit: err.message });
            setSubmitting(false);
          }
        }
      }}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
        <form
          noValidate
          onSubmit={handleSubmit}
          {...props}
        >
          <TextField
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            label="Email Address"
            margin="normal"
            name="email"
            onBlur={handleBlur}
            onChange={handleChange}
            type="email"
            value={values.email}
            variant="outlined"
          />
          <TextField
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            label="Password"
            margin="normal"
            name="password"
            onBlur={handleBlur}
            onChange={handleChange}
            type="password"
            value={values.password}
            variant="outlined"
          />
          {errors.submit && (
            <Box sx={{ mt: 3 }}>
              <FormHelperText error>
                {errors.submit}
              </FormHelperText>
            </Box>
          )}
          <Box sx={{ mt: 2 }}>
            <Button
              color="primary"
              disabled={isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              sx={{
                borderRadius: '25px',

              }}
            >
              Log In
            </Button>
          </Box>
          <Divider sx={{ my: 3 }} />
          <Link
            color="textSecondary"
            component={RouterLink}
            sx={{ mt: 0 }}
            to={"/authentication/forgot-password"}
            variant="body2"
          >
            Forgot password
          </Link>
        </form>
      )}
    </Formik>
  );
};

export default LoginJWT;
